import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Products16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_425)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.75 2C3.75 1.30964 4.30964 0.75 5 0.75H14C14.6904 0.75 15.25 1.30964 15.25 2V11C15.25 11.6904 14.6904 12.25 14 12.25H5C4.30964 12.25 3.75 11.6904 3.75 11V2ZM5.25 2.25V3.75H6.75V2.25H5.25ZM5.25 10.75V5.25H13.75V10.75H5.25ZM13.75 2.25V3.75H8.25V2.25H13.75Z'
        fill='currentColor'
      />
      <path
        d='M2.25 4.5V13.75H11.5V15.25H2C1.30964 15.25 0.75 14.6904 0.75 14V4.5H2.25Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_425'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Products16.displayName = 'Products16';
export default Products16;
